import { useCurrency, shortPrice } from './shared'
import { t } from '../../../i18n'

const SLAB = "'Rockwell', 'Roboto Slab', 'Courier New', serif"

// Steakhouse: every section opens with a full-width photo banner (taken
// from that section's own dishes), then heavy slab-serif rows with big
// brick-red prices on dark wood. Reads like signage in the dining room.
export default function SteakhouseTemplate({ menu, table, addItem, onSelectItem }) {
  const currency = useCurrency()
  const categories = menu.filter(c => c.items?.length)

  return (
    <div className="max-w-5xl mx-auto rounded-2xl overflow-hidden text-[#efe6d8]" style={{ background: '#1c1410', fontFamily: SLAB }}>
      <header className="px-6 md:px-12 py-14 text-center border-b-4 border-[#a3321f]">
        <p className="text-xs tracking-[0.5em] text-[color:var(--brand,#c9a27a)]">{t("EST. FIRE · SALT · TIME")}</p>
        <h1 className="text-5xl md:text-7xl font-black uppercase mt-3">{t("The Grill")}</h1>
        {table && <p className="mt-4 inline-block border border-[color:var(--brand,#c9a27a)] px-4 py-1 text-sm tracking-widest">{t("TABLE")} {table}</p>}
      </header>

      {categories.map(c => {
        const banner = c.items.find(i => i.image)?.image
        return (
          <section key={c.id}>
            <div className="relative h-44 md:h-60 bg-[#3a2418] overflow-hidden">
              {banner && <img loading="lazy" src={banner} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" onError={e => { e.currentTarget.style.display = 'none' }} />}
              <div className="absolute inset-0 bg-gradient-to-r from-[#1c1410] via-[#1c1410]/70 to-transparent" />
              <div className="relative h-full flex flex-col justify-end px-6 md:px-12 pb-6">
                <span className="text-[color:var(--brand,#c9a27a)] text-xs tracking-[0.4em]">{c.items.length} {t("CUTS & PLATES")}</span>
                <h2 className="text-4xl md:text-5xl font-black uppercase">{c.name}</h2>
              </div>
            </div>
            <ul className="px-6 md:px-12 py-6 divide-y divide-[#efe6d8]/10">
              {c.items.map(item => (
                <li key={item.id} className="py-5 flex items-center gap-5">
                  <button onClick={() => onSelectItem(item)} className="flex-1 min-w-0 text-start">
                    <h3 className="text-xl font-bold uppercase tracking-wide">{item.name}</h3>
                    {item.description && <p className="text-sm text-[#bda892] mt-1 font-sans">{t(item.description)}</p>}
                  </button>
                  <div className="text-end shrink-0">
                    <p className="text-3xl font-black text-[#e0573b]">{shortPrice(item.price)}<span className="text-sm ms-1 text-[color:var(--brand,#c9a27a)]">{currency}</span></p>
                    <button onClick={() => addItem(item)} className="mt-1 text-xs tracking-[0.3em] text-[color:var(--brand,#c9a27a)] hover:text-white border-b border-[color:var(--brand,#c9a27a)]">{t("ORDER")}</button>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        )
      })}
    </div>
  )
}
